import { render } from "./Payment.vue?vue&type=template&id=08f0cee5&scoped=true"
import script from "./Payment.vue?vue&type=script&lang=js"
export * from "./Payment.vue?vue&type=script&lang=js"

import "./Payment.vue?vue&type=style&index=0&id=08f0cee5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08f0cee5"]])

export default __exports__